/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum LookupCreationMode {
  ExistingOnly = 'ExistingOnly',
  CreateOnly = 'CreateOnly',
  CreateAndExisting = 'CreateAndExisting'
}
